import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

/**
 * ConfirmDialog Component
 * Reusable confirmation dialog for delete/action confirmations
 * Compact, professional dialog design
 */
const ConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action',
  message = 'Are you sure you want to perform this action?'
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: 400,
        }
      }}
    >
      <DialogTitle 
        id="confirm-dialog-title"
        sx={{ 
          fontSize: '1rem', 
          fontWeight: 600, 
          pb: 1.5,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <DialogContentText 
          id="confirm-dialog-description"
          sx={{ fontSize: '0.875rem' }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, pb: 2, gap: 1 }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          size="small"
          sx={{ fontSize: '0.875rem' }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleConfirm} 
          color="error" 
          variant="contained" 
          size="small"
          autoFocus
          sx={{ fontSize: '0.875rem' }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
